import Base from './base';

export default class Inventory extends Base{
  public async detail(supplier_name: string, sku: string) {
    const endpoint: string = `/inventory/${supplier_name}/${sku}`;
    const res: any = await this.get(endpoint);
    return res;
  }
}
